/*
 * Radiance Veil "My Account" page (/apps/rv/account, built by the Customer app's Worker: src/profile.js).
 *  - Tabs (Wishlists / My reviews / Veil Points / Birthday) switch in place and keep ?tab= in the address.
 *  - Birthday form: saved once to the customer's private profile (POST /apps/rv/profile/birthday).
 * Veil Points, Track an order and the wishlist pop-ups keep working as pop-ups from here.
 */
(function () {
  var page = document.querySelector('.rv-acct');
  if (!page) return;

  function show(tab, push) {
    var panel = page.querySelector('[data-rv-panel="' + tab + '"]');
    if (!panel) return;
    page.querySelectorAll('[data-rv-panel]').forEach(function (p) { p.hidden = p !== panel; });
    page.querySelectorAll('[data-rv-tab]').forEach(function (t) {
      var on = t.getAttribute('data-rv-tab') === tab;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
    });
    if (push) history.replaceState(null, '', '/apps/rv/account?tab=' + tab);
  }
  page.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rv-tab]');
    if (!t) return;
    e.preventDefault();
    show(t.getAttribute('data-rv-tab'), true);
  });

  // Veil Points: trade 200 points for a $10-off code (POST /apps/rv/points/redeem), then show it on the refreshed tab.
  page.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-rv-copy]');
    if (copy) {
      var code = copy.getAttribute('data-rv-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800);
      }).catch(function () {});
      return;
    }
    var btn = e.target.closest('[data-rv-redeem]');
    if (!btn || btn.disabled) return;
    var msg = page.querySelector('[data-rv-redeem-msg]');
    btn.disabled = true; msg.textContent = 'Creating your code…';
    page.querySelectorAll('[data-rv-redeem]').forEach(function (b) { b.disabled = true; });
    fetch('/apps/rv/points/redeem', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ value: Number(btn.getAttribute('data-rv-redeem')) || 10 }) })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r.ok) { window.location.replace('/apps/rv/account?tab=points'); return; }
        page.querySelectorAll('[data-rv-redeem]').forEach(function (b) { b.disabled = false; });
        msg.textContent = r.reason === 'points' ? 'You don’t have enough points for this reward.' : r.reason === 'slow_down' ? 'One moment, then try again.' : 'Something went wrong. Your points are safe. Please try again.';
      })
      .catch(function () { page.querySelectorAll('[data-rv-redeem]').forEach(function (b) { b.disabled = false; }); msg.textContent = 'Something went wrong. Please try again.'; });
  });

  var form = page.querySelector('[data-rv-birthday]');
  if (!form) return;
  var msg = page.querySelector('[data-rv-birthday-msg]');
  var DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  form.month.addEventListener('change', function () {
    var max = DAYS[(parseInt(form.month.value, 10) || 1) - 1];
    Array.prototype.forEach.call(form.day.options, function (o) { if (o.value) o.disabled = Number(o.value) > max; });
    if (Number(form.day.value) > max) form.day.value = '';
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!form.month.value || !form.day.value) { msg.textContent = 'Please choose the month and day.'; return; }
    var btn = form.querySelector('button'); btn.disabled = true; msg.textContent = 'Saving…';
    fetch('/apps/rv/profile/birthday', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ month: form.month.value, day: form.day.value })
    }).then(function (r) { return r.json(); }).then(function (r) {
      if (r.ok || r.reason === 'locked') {
        form.outerHTML = '<p class="rv-acct__bday">Your birthday: <strong></strong></p>';
        page.querySelector('.rv-acct__bday strong').textContent = r.birthday;
        msg.textContent = r.ok ? 'Saved! We’ll add your Veil Points on your birthday.' : '';
        var fine = page.querySelector('[data-rv-panel="birthday"] .rv-acct__fine');
        if (fine) fine.innerHTML = 'Need to change it? Email <a href="mailto:support@radianceveil.com">support@radianceveil.com</a>.';
      } else {
        btn.disabled = false;
        msg.textContent = r.reason === 'slow_down' ? 'Too many tries. Please wait a minute.' : 'Something went wrong. Please try again.';
      }
    }).catch(function () { btn.disabled = false; msg.textContent = 'Something went wrong. Please try again.'; });
  });
})();
